import React from "react";
import PropTypes from "prop-types";
import styles from "./TourSkipped.module.scss";
import FYIIcon from "../../assets/icons/fyi_icon.svg";

const TourSkipped = ({ showOnboarding }) => {
  return (
    <div className={styles.tourSkipped}>
      <div>
        <img src={FYIIcon} alt="FYI" />
      </div>
      <div className={styles.tourSkippedText}>Want to see how it works?</div>
      <button
        className={styles.tourSkippedLink}
        type="button"
        onClick={() => showOnboarding()}
      >
        Hop on the express tour
      </button>
    </div>
  );
};

TourSkipped.propTypes = {
  showOnboarding: PropTypes.func.isRequired,
};

export default TourSkipped;
